<!--

 -->

<template>
  <div class="gsl-hrm-background-container">
    <div class="gsl-hrm-card-container">
      <oxd-text class="gsl-hrm-main-title">{{
        $t('pim.edit_termination_reason')
      }}</oxd-text>

      <oxd-divider />

      <oxd-form :loading="isLoading" @submit-valid="onSave">
        <oxd-form-row>
          <oxd-input-field
            v-model="termination.name"
            :label="$t('general.name')"
            :rules="rules.name"
            required
          />
        </oxd-form-row>

        <oxd-divider />

        <oxd-form-actions>
          <required-text />
          <oxd-button
            type="button"
            display-type="ghost"
            :label="$t('general.cancel')"
            @click="onCancel"
          />
          <submit-button />
        </oxd-form-actions>
      </oxd-form>
    </div>
  </div>
</template>

<script>
import {navigate} from '@ohrm/core/util/helper/navigation';
import {APIService} from '@ohrm/core/util/services/api.service';
import {
  required,
  shouldNotExceedCharLength,
} from '@ohrm/core/util/validation/rules';

export default {
  props: {
    terminationReasonId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const http = new APIService(
      window.appGlobal.baseUrl,
      '/api/v2/pim/termination-reasons',
    );
    return {
      http,
    };
  },

  data() {
    return {
      isLoading: false,
      termination: {
        id: '',
        name: '',
      },
      rules: {
        name: [required, shouldNotExceedCharLength(100)],
      },
    };
  },

  created() {
    this.isLoading = true;
    this.http
      .get(this.terminationReasonId)
      .then((response) => {
        const {data} = response.data;
        this.termination.id = data.id;
        this.termination.name = data.name;
        // Fetch list data for unique test
        return this.http.getAll({limit: 0});
      })
      .then((response) => {
        const {data} = response.data;
        this.rules.name.push((v) => {
          const index = data.findIndex((item) => item.name === v);
          if (index > -1) {
            const {id} = data[index];
            return id !== this.termination.id
              ? this.$t('general.already_exists')
              : true;
          } else {
            return true;
          }
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  },

  methods: {
    onSave() {
      this.isLoading = true;
      this.http
        .update(this.terminationReasonId, {
          name: this.termination.name,
        })
        .then(() => {
          return this.$toast.updateSuccess();
        })
        .then(() => {
          this.onCancel();
        });
    },
    onCancel() {
      navigate('/pim/viewTerminationReasons');
    },
  },
};
</script>
